import Image from 'next/image';
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'

interface SecChooseProps {
	heading?: {
		title?: string
	}
	text_left_section?: {
		text?: string
	}
	text_right_section?: {
		text?: string
	}
	text_bottom_section?: {
		text?: string
	}
	background_desktop?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_disk: string
			}
		}
	}
	background_mobile?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_disk: string
			}
		}
	}
	button?: {
		href: string
		label: string
	}
}

export const fields = [
	'heading.title',
	'text_left_section.text',
	'text_right_section.text',
	'text_bottom_section.text',

	'background_desktop.alt',
	'background_desktop.image_file.image.id',
	'background_desktop.image_file.image.filename_download',
	'background_mobile.alt',
	'background_mobile.image_file.image.id',
	'background_mobile.image_file.image.filename_download',

	'button.href',
	'button.label',
] as const

export default function SecChoose({ data }: { data: SecChooseProps }) {
  return (
		<section id='choose' className='SecChoose relative bg-white'>
			{/* Background Image */}
			<div className='lg:absolute inset-0 w-full h-full relative aspect-[808/711] overflow-hidden'>
				<picture>
					<source
						srcSet={getReadableImageUrl(
							data?.background_desktop?.image_file?.image?.id || '',
							data?.background_desktop?.image_file?.image?.filename_disk || ''
						)}
						media='(min-width: 1024px)'
						type='image/webp'
					/>
					<Image
						src={getReadableImageUrl(
							data?.background_mobile?.image_file?.image?.id || '',
							data?.background_mobile?.image_file?.image?.filename_disk || ''
						)}
						alt={data?.background_mobile?.alt || ''}
						fill
						className='object-cover object-center lg:object-[24%_0]'
						priority
						quality={100}
					/>
				</picture>
			</div>

			{/* Content Container */}
			<div className='container relative 2xl:py-24 py-14 flex justify-end'>
				<div className='lg:w-9/12'>
					<div className='flex items-center justify-center gap-10 mb-9 md:mb-14'>
						<Image
							src='/images/logo_h.svg'
							alt='Dr. Harmon Logo'
							width={99}
							height={99}
							className='w-[6.188rem] h-[6.188rem] max-md:absolute max-md:top-[-55px] max-md:right-[15px] max-md:w-[4rem]'
						/>
						<h2>{data?.heading?.title || ''}</h2>
					</div>

					{/* Two Column Content */}
					<div className='grid md:grid-cols-2 md:gap-7 md:mb-14'>
						<div
							className='md:p-10 bg-white/75 rounded-lg [&>p]:text-base [&>p]:mb-5 [&>p]:leading-7'
							dangerouslySetInnerHTML={sanitizeHTML(
								data?.text_left_section?.text || ''
							)}
						/>

						<div
							className='md:p-10 bg-white/75 rounded-lg [&>p]:text-base [&>p]:mb-5 [&>p]:leading-7'
							dangerouslySetInnerHTML={sanitizeHTML(
								data?.text_right_section?.text || ''
							)}
						/>
					</div>

					{/* Quad A Section */}
					{data?.text_bottom_section?.text && (
						<div className='md:p-10 bg-white/75 rounded-lg mb-14'>
							<div
								className='[&>h3]:text-2xl [&>h3]:mb-5'
								dangerouslySetInnerHTML={sanitizeHTML(
									(data?.text_bottom_section?.text || '').replace(
										/<p>/g,
										'<p class="text-base mb-5 leading-7">'
									)
								)}
							/>
							<div className='h-px bg-black mt-6 hidden md:block'></div>
						</div>
					)}

					{/* CTA Button */}
					{data?.button && (
						<div className='flex md:justify-end'>
							<a
								href={data.button.href}
								className='btn'
							>{data.button.label}</a>
						</div>
					)}
				</div>
			</div>
		</section>
	)
}